export class AmenityDetailResultDto {
  name: string;
  description: string;
  reservable: boolean;
  hours: string;
  amenityRules: string;
  accessRules: string;
  phone: string;
  address: string;
  reservationFormId: number;
  reservationFormDownloadUrl: string;
  reservationProcess: string;
}
